import {
  ActionTypes as SearchPageActionTypes,
  TypeKeys as SearchPageTypeKeys
} from '../actions/searchPage'

import { IRecommendedSearches } from '../../typings/recommendedSearches'
import { IProxySearchResults } from '../../typings/searchResults'
import {
  ISearchHeadings,
  ISearchIngestedContent
} from '../../typings/seoMetadata'
import { IStudioRecommendations } from '../../typings/studioRecommendations'

export interface IState {
  readonly activeAudio: string
  readonly ingestedContent: ISearchIngestedContent | null
  readonly licenses: any
  readonly loading: boolean
  readonly relatedSearches: IRecommendedSearches
  readonly results: IProxySearchResults
  readonly searchHeadings: ISearchHeadings
  readonly showModal: boolean
  readonly showSidebar: boolean
  readonly similarItems: any
  readonly studioRecommendations: IStudioRecommendations
  readonly timeout: boolean
  readonly hostingSetupSearch: boolean
}

const initialState: IState = {
  activeAudio: '',
  ingestedContent: null,
  licenses: {},
  loading: false,
  relatedSearches: {
    recommendations: []
  },
  results: {
    aggregations: {},
    matches: [],
    total_hits: 0,
    author_exists: null,
    links: {},
    timed_out: false,
    suggestions: [],
    took: 0,
    metadata: {
      description: '',
      heading: '',
      sub_heading: '',
      title: ''
    }
  },
  searchHeadings: {
    heading: ''
  },
  showModal: false,
  showSidebar: false,
  similarItems: {},
  studioRecommendations: {
    generation: 0,
    items: []
  },
  timeout: false,
  hostingSetupSearch: false
}

export const reducer = (
  state = initialState,
  action: SearchPageActionTypes
): IState => {
  switch (action.type) {
    case SearchPageTypeKeys.SET_ACTIVE_AUDIO:
      return {
        ...state,
        activeAudio: action.payload.activeAudio
      }

    case SearchPageTypeKeys.SET_HOSTING_SETUP_SEARCH:
      return {
        ...state,
        hostingSetupSearch: action.payload.hostingSetupSearch
      }

    case SearchPageTypeKeys.GET_SEARCH_RESULTS_REQUEST:
      return {
        ...state,
        loading: true,
        relatedSearches: {
          recommendations: []
        },
        timeout: false
      }

    case SearchPageTypeKeys.GET_SEARCH_RESULTS_SUCCESS:
      return {
        ...state,
        loading: false,
        results: action.payload.results
      }

    case SearchPageTypeKeys.GET_SEARCH_RESULTS_FAIL:
      return {
        ...state,
        loading: false,
        timeout: action.timeout
      }

    case SearchPageTypeKeys.GET_RECOMMENDED_SEARCHES_BY_TERM_RESULTS_SUCCESS:
      return {
        ...state,
        relatedSearches: {
          hint: action.payload.hint,
          recommendations: action.payload.recommendations,
          type: action.payload.type
        }
      }

    case SearchPageTypeKeys.GET_RECOMMENDED_SEARCHES_BY_CATEGORY_RESULTS_SUCCESS:
      return {
        ...state,
        relatedSearches: {
          hint: action.payload.hint,
          recommendations: action.payload.recommendations,
          type: action.payload.type
        }
      }

    case SearchPageTypeKeys.SET_SEARCH_HEADINGS:
      return {
        ...state,
        searchHeadings: {
          heading:
            action.payload.heading || initialState.searchHeadings.heading,
          sub_heading:
            action.payload.sub_heading ||
            initialState.searchHeadings.sub_heading,
          fine_print:
            action.payload.fine_print || initialState.searchHeadings.fine_print
        }
      }

    case SearchPageTypeKeys.SET_STUDIO_RECOMMENDATIONS:
      return {
        ...state,
        studioRecommendations: action.payload
      }

    case SearchPageTypeKeys.GET_INGESTED_CONTENT_SUCCESS:
      return {
        ...state,
        ingestedContent: action.payload.content || initialState.ingestedContent
      }

    case SearchPageTypeKeys.GET_ITEM_LICENCES_SUCCESS: {
      const { itemID, licenses } = action.payload

      return {
        ...state,
        licenses: { ...state.licenses, [itemID]: licenses }
      }
    }

    case SearchPageTypeKeys.GET_ITEM_LICENCES_FAIL: {
      const { itemID, error } = action.payload

      return {
        ...state,
        licenses: { ...state.licenses, [itemID]: { error } }
      }
    }

    case SearchPageTypeKeys.GET_SIMILAR_ITEMS_SUCCESS: {
      const { itemID, similarItems } = action.payload

      return {
        ...state,
        similarItems: { ...state.similarItems, [itemID]: similarItems }
      }
    }

    case SearchPageTypeKeys.GET_SIMILAR_ITEMS_FAIL: {
      const { itemID, error } = action.payload

      return {
        ...state,
        similarItems: { ...state.similarItems, [itemID]: { error } }
      }
    }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./common/reducers/searchPage.ts